import { render, staticRenderFns } from "./BaseExpansionPanel.vue?vue&type=template&id=114380f2&scoped=true"
import script from "./BaseExpansionPanel.vue?vue&type=script&lang=js"
export * from "./BaseExpansionPanel.vue?vue&type=script&lang=js"
import style0 from "./BaseExpansionPanel.vue?vue&type=style&index=0&id=114380f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114380f2",
  null
  
)

export default component.exports